import script from "./LiveTraining.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveTraining.vue?vue&type=script&setup=true&lang=js"

import "./LiveTraining.vue?vue&type=style&index=0&id=c90f770a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c90f770a"]])

export default __exports__